import type { TranslationParams, Paths } from './types'

// backend can import and call this function to send eg domain errors to frontend. frontend will pass the args to t()
export function makeI18nArgs<Translations>() {
  return <K extends Paths<Translations>>(
    key: K,
    ...params: TranslationParams<Translations, undefined, K> extends undefined
      ? [params?: undefined]
      : [params: TranslationParams<Translations, undefined, K>]
  ) => {
    return (
      params[0] === undefined ? [key] : [key, params[0]]
    ) as TranslationParams<Translations, undefined, K> extends undefined
      ? [K]
      : [K, TranslationParams<Translations, undefined, K>]
  }
}
